import { render } from "./fundsTransfe.vue?vue&type=template&id=0ecc2f86&scoped=true"
import script from "./fundsTransfe.vue?vue&type=script&lang=js"
export * from "./fundsTransfe.vue?vue&type=script&lang=js"

import "./fundsTransfe.vue?vue&type=style&index=0&id=0ecc2f86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecc2f86"]])

export default __exports__